module.exports = __webpack_public_path__ + "media/12.25a8c256.mp3";